import { render, staticRenderFns } from "./DietaryRestrictionsCard.vue?vue&type=template&id=25f4bb76&scoped=true"
import script from "./DietaryRestrictionsCard.vue?vue&type=script&lang=js"
export * from "./DietaryRestrictionsCard.vue?vue&type=script&lang=js"
import style0 from "./DietaryRestrictionsCard.vue?vue&type=style&index=0&id=25f4bb76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f4bb76",
  null
  
)

export default component.exports